import { Injectable } from '@angular/core';

import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import * as fromRouter from '../actions';
import { AccountsService } from '../../data';
import * as authActions from '../actions';
import { AppLocalStorage } from '../../helpers';

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions, private accountsService: AccountsService) { }


  @Effect()
  login$ = this.actions$.ofType(authActions.AuthActionTypes.Login).pipe(
    map((action: authActions.Login) => action.payload),
    switchMap(credentials => {
      return this.accountsService.login(credentials.username, credentials.password).pipe(
        map(result => new authActions.LoginSuccess(result)),
        catchError(error => of(new authActions.LoginFailure(error)))
      )
    })
  );

  @Effect()
  loginSuccess$ = this.actions$.ofType(authActions.AuthActionTypes.LoginSuccess).pipe(
      map((action: authActions.LoginSuccess) => action.payload),
      map(result => {
        AppLocalStorage.authToken = result.auth_token;

        return new fromRouter.Go({
        path: ['/'],
      });
    })
  );

  @Effect()
  loginRedirect$ = this.actions$.ofType(authActions.AuthActionTypes.LoginRedirect).pipe(
      map(authed => {
        AppLocalStorage.clear();
        return new fromRouter.Go({
        path: ['/account/login'],
      });
    })
  );

  @Effect()
  logout$ = this.actions$.ofType(authActions.AuthActionTypes.Logout).pipe(
    map(authed => {
      AppLocalStorage.clear();
      return new fromRouter.Go({
        path: ['/account/login'],
      });
    })
  );

  @Effect()
  loadUser$ = this.actions$.ofType(authActions.AuthActionTypes.LoadUser)
    .switchMap(() => {
      return this.accountsService.getUser()
        .map(user => new authActions.LoadUserSuccess(user))
        .catch(error => of(new authActions.LoginRedirect()));
    });

}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/auth.effects.ts